export const empresasBrasileiras = [
  "Itaú Unibanco", "Banco do Brasil", "Bradesco", "Caixa Econômica Federal",
  "Petrobras", "Vale", "Nubank", "Ambev", "WEG", "Embraer",
  "Natura", "Boticário", "Gerdau", "Suzano", "Localiza",
  "Mercado Livre", "Shopee Brasil", "Ifood", "Hapvida", "Rede D'Or",
  "Google", "Apple", "Amazon", "Microsoft", "Meta",
  "Magazine Luiza", "Casas Bahia", "Lojas Renner", "C&A Brasil", "Riachuelo",
  "Carrefour Brasil", "Assaí Atacadista", "Atacadão", "Pão de Açúcar", "Lojas Americanas",
  "JBS", "BRF", "Marfrig", "Nestlé Brasil", "PepsiCo Brasil",
  "Coca-Cola FEMSA Brasil", "M. Dias Branco", "Camil Alimentos", "Aurora Alimentos", "Seara Alimentos",
  "Whirlpool", "Siemens Brasil", "3M do Brasil", "BASF", "Tupy",
  "Marcopolo", "Randon", "Klabin", "ArcelorMittal Brasil", "Usiminas",
  "Alpargatas", "Grendene", "Votorantim", "CSN", "Duratex"
];